
import {
  Box, Button, Card, CardContent, CardHeader, Checkbox, debounce, Divider, Grid, Paper, Stack, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer,
  TableHead, TableRow, TextField, Typography, useMediaQuery
} from '@mui/material';
import { ExistingPartner, SubPartnersKobHoved, Ta1AdminKobhoved } from '../../../app/models/partners';
import { collectionFormStyles } from '../../basicUser/basicUserForms/collectionFormStyles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { koReportingContainerStyles } from '../../basicUser/koreporting/reports/koReportingContainerStyles';
import { useEffect, useState } from 'react';
import { useStore } from '../../../app/stores/store';
import { observer } from 'mobx-react-lite';
import NewPartnerForm from './NewPartnerForm';
import React from 'react';
import { mainStyles } from '../../mainStyles';
import { adminUserStyles } from '../adminUsers/adminUserStyles';


const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#fcfcfc',
    fontSize: 16,
    fontWeight: 300,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontWeight: 300,
    fontStrethed: 'expanded',
  },
}));
const StyledTableRow = styled(TableRow)(() => ({

  '&:nth-of-type(odd)': {
    backgroundColor: '#DAE5F1',
  },
  '&:nth-of-type(even)': {
    backgroundColor: '#fcfcfc',
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const gridContainer = {
  xs: 1,
  sm: 2,
  md: 3
} as const;

const textGen = (title: string, value: any, xs: number, sm: number) => {
  return <Grid item xs={xs} sm={sm} key={title}>
      <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
      >
          {title}&nbsp;{value || "---"}
      </Stack>
  </Grid>
}

interface Props {
  selectedKobhoveds: Ta1AdminKobhoved[] | SubPartnersKobHoved[];
  backBtnHandler: () => void;
}

const ExistingPartnerForm = ({ selectedKobhoveds, backBtnHandler }: Props) => {

  const [isSelect, setIsSelect] = useState(false);
  const [createPartner, setCreatePartner] = useState<ExistingPartner | null>(null);
  const [searchValue, setSearchValue] = useState('');

  const { adminStore } = useStore();
  const { existingPartners, resetExistingPartner, selectExistingPartner, createPartnerLoading } = adminStore;

  useEffect(() => {
    const debouncedSearch = debounce(() => {
      if (searchValue)
        selectExistingPartner(searchValue);
    }, 1000)
    debouncedSearch();
  }, [searchValue, selectExistingPartner])

  useEffect(() => {
    if (!searchValue && existingPartners.length > 0)
      resetExistingPartner();
  }, [existingPartners.length, resetExistingPartner, searchValue])


  const createHandler = (partner: ExistingPartner) => {
    setIsSelect(true);
    setCreatePartner(partner);
  }
  const backToSearchHandler = () => {
    setIsSelect(false);
    setCreatePartner(null);
  }
  const matches = useMediaQuery('(min-width:900px)');

  return (
    <Box component={'div'} sx={collectionFormStyles.newPartnerFormContainer}>
      {selectedKobhoveds &&

        <Box sx={{ direction: 'row' }}>
          {!isSelect
            ?
            <React.Fragment>
              <Box component={'div'} sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>

                <Box component='div' sx={collectionFormStyles.partnerFormControls}>
                  <ArrowBackIcon sx={{ color: '#000', cursor: 'pointer' }} onClick={() => backBtnHandler()} />
                  <Divider sx={{ m: '10px 10px' }} />
                  <Stack direction="row" spacing={2} m={2} alignItems='center' justifyContent="center">
                    <TextField label="Email" variant="outlined"
                      id="email"
                      name="email"
                      onChange={(event: any) => setSearchValue(event.target.value)}
                      value={searchValue} />
                  </Stack>
                </Box>
              </Box>

              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>

                {!createPartnerLoading && existingPartners.length < 1 &&
                  <Typography>Type email to find existing partners</Typography>
                }
                {/*Desktop view */}
                {matches && !createPartnerLoading && existingPartners && existingPartners.length > 0 &&
                  <TableContainer component={Paper} sx={koReportingContainerStyles.table}>
                    <Table aria-label="Partner table">
                      <TableHead key={'tableKey'}>
                        <TableRow>
                          <StyledTableCell>
                            Select
                          </StyledTableCell>
                          <StyledTableCell sx={{ cursor: 'pointer' }}>User Name</StyledTableCell>
                          <StyledTableCell sx={{ cursor: 'pointer' }}>Email</StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {existingPartners.map((partner) => (
                          <StyledTableRow key={partner.userName}>
                            <StyledTableCell>
                              <Button variant='outlined' onClick={() => createHandler(partner)} >Create</Button>
                            </StyledTableCell>
                            <StyledTableCell>
                              {partner.userName}
                            </StyledTableCell>
                            <StyledTableCell>
                              {partner.email}
                            </StyledTableCell>
                          </StyledTableRow>
                        ))
                        }
                      </TableBody>
                    </Table>
                  </TableContainer>
                }
                {/*Mobile View */}
                {!matches && !createPartnerLoading && existingPartners && existingPartners.length > 0 &&
                <Box sx={{ flexGrow: 1, mt:4 }}>
                <Grid container spacing={2} direction="column" justifyContent="center"
                    alignItems="center">
                    {existingPartners.map((partner) => {
                        return (
                            <Grid item xs={12} key={partner.email}
                                sx={{
                                    position: 'relative', pb: 0.5, pr: 0.5, mt: 2,
                                    bgcolor: '#000',
                                    borderRadius: '100% 0% 29% 71% / 0% 100% 0% 100% '
                                }} >
                                <Typography component='span' variant='body2'
                                    sx={{ position: 'absolute', right: 6, top: 0.1, color: '#fff' }}>
                                    Tier1Asset
                                </Typography>
                                <Card sx={mainStyles.cardStyles}>
                                    {/* <CardHeader
                                     action={
                                        <Checkbox
                                        checked={partner.isChecked}
                                            value={partner.isChecked}
                                            onChange={() => createHandler(partner)}
                                            inputProps={{ 'aria-label': partner.email }}
                                            sx={adminUserStyles.adminCheckBoxStyle}
                                        />
                                    }
                                        title={partner.email}
                                        subheader={partner.userName}
                                    /> */}
                                    <CardContent>
                                        <Grid container direction='row' wrap='wrap' rowSpacing={1} columnSpacing={gridContainer}>
                                        <Button sx={{color:'#fff'}} variant='outlined' onClick={() => createHandler(partner)} >Create</Button>
                                            {textGen('Email:',partner.email, 12, 6)}
                                            {textGen('Username:', partner.userName, 12, 6)}
                                        </Grid>
                                    </CardContent>
                                    
                                </Card>
                            </Grid>
                        )
                    })}
                </Grid>
            </Box>
                }
              </Box>
            </React.Fragment>
            :
            <NewPartnerForm selectedKobhoveds={selectedKobhoveds} backBtnHandler={backToSearchHandler} backBtnHandlerToSearch={backBtnHandler} select={isSelect} selectPartner={createPartner!} />
          }
        </Box>
      }
    </Box >
  )
}
export default observer(ExistingPartnerForm);